<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">For my wonderful parents, Ellen and Artie Schloss.<br/>You empower me with confidence and love.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429983969_epub_ded_r1.vue?78c53a9b